module.exports = __webpack_public_path__ + "static/variety-image-1-8b4fa72c66625ef261e1dec285f5f308.jpg";